<template>
  <div style="width: 100%">
    <!-- <v-btn color="primary" @click="ctrl.onCancel()" icon>
      <v-icon>mdi-undo</v-icon>
   </v-btn> -->
    <v-toolbar flat dense>
      <v-row no-gutters align="center">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="ctrl.onAdd()" small>
          <v-icon size="18" class="mr-1">mdi-plus</v-icon>
          <span>Add</span>
        </v-btn>
      </v-row>
    </v-toolbar>

    <v-data-table :loading="ctrl.loading" hide-default-footer dense :headers="ctrl.headers || []" :items="ctrl.list"
      :items-per-page="-1" class="elevation-0">
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" x-small v-on="on">options</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="ctrl.onEdit(item)">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="ctrl.delete(item)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
            <slot name="extra_actions" :item="item"></slot>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    props: {
      controller: String,
      title: String,
    },
    data() {
      return {
        ctrl: this.get_controller(this.controller),
      };
    },
    mounted() {
      console.log(this.ctrl);
    },
  };
</script>